import MemberFDIC from "../icons/MemberFDIC";
import React from "react";
import styles from "./Footer.module.css";

const TODAY = new Date();

const strings = {
    copyright: `Copyright © 2001-${TODAY.getFullYear()} 1st Financial Bank USA - Member FDIC`,
};

export default function Footer() {
    return (
        <div className={styles.container}>
            <div className={styles.copyright}>{strings.copyright}</div>
            <MemberFDIC className={styles.fdic} />
        </div>
    );
}
